<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="con01"><a id="page05">
<h2 class="contentsHead"><span class="bold">Contents</span></h2>
</a><div class="contentsEntry" id="ack_01"><a id="page05">
</a><p class="contentsEntryName"><a id="page05"></a><a href="#/9780061745287_frontmatterpage#ack01">Acknowledgments</a></p>
</div>
<div class="contentsEntry" id="int_01">
<p class="contentsEntryName"><a href="#/9780061745287_frontmatterpage_02#int01">Introduction</a></p>
</div>
<br/>
<div class="contentsEntry" id="ch_01">
<p class="contentsEntryNumber"><a href="#/9780061745287_chapter_01#ch01">1   The Basics</a></p>
</div>
<div class="contentsEntry" id="ch_02">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_02#ch02" title="Link target outside of Sample">2   Growing Up</span></p>
</div>
<div class="contentsEntry" id="ch_03">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_03#ch03" title="Link target outside of Sample">3   Coming Out/Going Public</span></p>
</div>
<div class="contentsEntry" id="ch_04">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_04#ch04" title="Link target outside of Sample">4   Family and Children</span></p>
</div>
<div class="contentsEntry" id="ch_05">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_05#ch05" title="Link target outside of Sample">5   For Parents of Gay Children</span></p>
</div>
<div class="contentsEntry" id="ch_06">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_06#ch06" title="Link target outside of Sample">6   Dating, Relationships, and Marriage</span></p>
</div>
<div class="contentsEntry" id="ch_07">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_07#ch07" title="Link target outside of Sample">7   Sex</span></p>
</div>
<div class="contentsEntry" id="ch_08">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_08#ch08" title="Link target outside of Sample">8   Work and the Military</span></p>
</div>
<div class="contentsEntry" id="ch_09">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_09#ch09" title="Link target outside of Sample">9   Where Gay and Lesbian People Live</span></p>
</div>
<div class="contentsEntry" id="ch_10">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_10#ch10" title="Link target outside of Sample">10  Socializing and Friends</span></p>
</div>
<div class="contentsEntry" id="ch_11">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_11#ch11" title="Link target outside of Sample">11  Religion</span></p>
</div>
<div class="contentsEntry" id="ch_12">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_12#ch12" title="Link target outside of Sample">12  Discrimination and Antigay Violence</span></p>
</div>
<div class="contentsEntry" id="ch_13">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_13#ch13" title="Link target outside of Sample">13  Movies, Television, and Print Media</span></p>
</div>
<div class="contentsEntry" id="ch_14">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_14#ch14" title="Link target outside of Sample">14  Sports</span></p>
</div>
<div class="contentsEntry" id="ch_15">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_15#ch15" title="Link target outside of Sample">15  Education</span></p>
</div>
<div class="contentsEntry" id="ch_16">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_16#ch16" title="Link target outside of Sample">16  Politics and Activism</span></p>
</div>
<div class="contentsEntry" id="ch_17">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_17#ch17" title="Link target outside of Sample">17  Aging</span></p>
</div>
<div class="contentsEntry" id="ch_18">
<p class="contentsEntryNumber"><span href="#/9780061745287_chapter_18#ch18" title="Link target outside of Sample">18  Miscellaneous Questions</span></p>
</div>
<br/>
<div class="contentsEntry" id="bib_01">
<p class="contentsEntryName"><span href="#/9780061745287_backmatterpage#bib01" title="Link target outside of Sample">Bibliography</span></p>
</div>
<div class="contentsEntry" id="bm_01">
<p class="contentsEntryName"><span href="#/9780061745287_backmatterpage_02#bm01" title="Link target outside of Sample">Resources</span></p>
</div>
<div class="contentsEntry" id="ind_01">
<p class="contentsEntryName"><span href="#/9780061745287_backmatterpage_03#ind01" title="Link target outside of Sample">Searchable Terms</span></p>
</div>
<div class="contentsEntry" id="ata_1">
<p class="contentsEntryName"><span href="#/9780061745287_aboutauthor#ata1" title="Link target outside of Sample">About the Author</span></p>
</div>
<div class="contentsEntry" id="adc_01">
<p class="contentsEntryName"><span href="#/9780061745287_adcard#adc01" title="Link target outside of Sample">Other Books by Eric Marcus</span></p>
</div>
<div class="contentsEntry" id="cop_01">
<p class="contentsEntryName"><span href="#/9780061745287_copyright#cop01" title="Link target outside of Sample">Copyright</span></p>
</div>
<div class="contentsEntry" id="atp_01">
<p class="contentsEntryName"><span href="#/9780061745287_aboutpublisher#atp01" title="Link target outside of Sample">About the Publisher</span></p>
</div>
<a id="page06"></a></div><a id="page06">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061745287_contents.vue?2dc80278